import { RESET_STORE } from "./types";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import fruitsReducer from "./reducers/fruitsReducer";
import { processorsReducer } from "./reducers/processorsReducer";
import { categoriesReducer } from "./reducers/categoriesReducer";
import { loginReducer } from "./reducers/loginReducer";
import { updateMeReducer } from "./reducers/updateMeReducer";
import { papersReducer } from "./reducers/papersReducers";
import { currentUserReducer } from "./reducers/currentUserReducer";
import { archiveReducer } from "./reducers/archiveReducer";
import { signupReducer } from "./reducers/signupReducer";
import { allUsersReducer } from "./reducers/allUsersReducer";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["sidebar"]
};

const appReducer = combineReducers({
  /* your app’s top-level reducers */
  allFruits: fruitsReducer,
  allProcessors: processorsReducer,
  allCategories: categoriesReducer,
  login: loginReducer,
  updateMe: updateMeReducer,
  papers: papersReducer,
  currentUser: currentUserReducer,
  archive: archiveReducer,
  signup: signupReducer,
  allUsers: allUsersReducer
});

const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === "LOGOUT") {
    state = {};
  }

  if (action.type === "CLEAN_STORE") {
    state = {};
  }

  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
